import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const BookIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(7);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Book Icon</title>;
    t1 = <path d="M4 8C4 5.17157 4 3.75736 4.87868 2.87868C5.75736 2 7.17157 2 10 2H14C16.8284 2 18.2426 2 19.1213 2.87868C20 3.75736 20 5.17157 20 8V16C20 18.8284 20 20.2426 19.1213 21.1213C18.2426 22 16.8284 22 14 22H10C7.17157 22 5.75736 22 4.87868 21.1213C4 20.2426 4 18.8284 4 16V8Z" stroke="currentColor" strokeWidth="1.5" />;
    t2 = <path d="M19.8978 16H7.89778C6.96781 16 6.50282 16 6.12132 16.1022C5.08604 16.3796 4.2774 17.1883 4 18.2235" stroke="currentColor" strokeWidth="1.5" />;
    t3 = <path d="M8 7H16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    t4 = <path d="M8 10.5H13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props) {
    t5 = <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}</svg>;
    $[5] = props;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};